<template>
  <ManagementVerSys />
</template>

<script>
import ManagementVerSys from '@/modules/management-verdesys/management-verdesys-details/accounts/AccountsDetails.vue'

export default {
  components: {
    ManagementVerSys,
  },
}
</script>

<style>

</style>
